import { render } from "./Amplitude.vue?vue&type=template&id=a5a9d2b0"
import script from "./Amplitude.vue?vue&type=script&lang=js"
export * from "./Amplitude.vue?vue&type=script&lang=js"

import "./Amplitude.vue?vue&type=style&index=0&id=a5a9d2b0&lang=css"
script.render = render

export default script